export const html = document.documentElement;
export const appEl = document.querySelector('.nm-app');
export const mapLoadingEl = document.getElementById('nm-map-loading');
export const selectionBannerEl = document.getElementById('nm-selection-banner');
export const selectionBannerTextEl = document.getElementById('nm-selection-banner-text');
export const selectionClearBtn = document.getElementById('nm-selection-clear-btn');
export const selectionShowBtn = document.getElementById('nm-selection-show-btn');
export const floatingPillbarEl = document.getElementById('nm-floating-pillbar');
export const floatingClearBtn = document.getElementById('nm-floating-clear-btn');
export const limitedBannerEl = document.getElementById('nm-limited-banner');
export const searchBtn = document.getElementById('nm-search-btn');
export const searchOverlay = document.getElementById('nm-search-overlay');
export const searchInput = document.getElementById('nm-search-input');
export const searchClose = document.getElementById('nm-search-close');
export const searchResultsEl = document.getElementById('nm-search-results');
export const geolocateBtn = document.getElementById('nm-geolocate-btn');
export const shareBtn = document.getElementById('nm-share-btn');
export const openFavoritesBtn = document.getElementById('nm-open-favorites');
export const favListEl = document.getElementById('nm-fav-list');
export const favListBodyEl = document.getElementById('nm-fav-list-body');
export const favListBackdropEl = document.getElementById('nm-fav-list-backdrop');
export const panelToggleBtn = document.getElementById('nm-panel-toggle');
export const topbarEl = document.querySelector('.nm-topbar');
export const listTitleEl = document.getElementById('nm-list-title');
export const listMetaEl = document.getElementById('nm-list-meta');
export const listTabCountEl = document.getElementById('nm-list-tab-count');
export const listContentEl = document.getElementById('nm-list-content');
export const listMoreBtn = document.getElementById('nm-list-more');
export const listMoreErrorEl = document.getElementById('nm-list-more-error');
export const listLoadingBarEl = document.getElementById('nm-list-loading-bar');
export const sortRowEl = document.getElementById('nm-sort-row');
export const listingSortRowEl = document.getElementById('nm-sort-row-listings');
export const listSubTabsEl = document.getElementById('nm-list-subtabs');
export const listingSortEls = document.querySelectorAll('[data-listing-sort]');
export const detailsMetaEl = document.getElementById('nm-details-meta');
export const detailsKickerEl = document.getElementById('nm-details-kicker');
export const detailsContentEl = document.getElementById('nm-details-content');

const DETAILS_KICKER_DEFAULT = 'Wybrany obiekt na mapie';

// Departments of DESIGN.md §5a. A panel section of one data family carries
// .ms-dept--<department>, which maps its accent (kicker, badges, active
// options) onto that family's colour; the map chrome stays brand amber.
const DEPARTMENTS = ['transactions', 'offers', 'cadastre', 'permits', 'environment', 'signals', 'statistics', 'sun', 'portal'];

export function setDepartment(el, department) {
    if (!el) return;
    DEPARTMENTS.forEach(function(name) {
        el.classList.remove('ms-dept--' + name);
    });
    if (department && DEPARTMENTS.indexOf(department) !== -1) {
        el.classList.add('ms-dept--' + department);
        el.setAttribute('data-department', department);
    } else {
        el.removeAttribute('data-department');
    }
}

export const pageHeadingEl = document.getElementById('nm-page-heading');
const PAGE_HEADING_DEFAULT = pageHeadingEl ? pageHeadingEl.textContent.trim() : 'Mapa cen nieruchomości w Polsce';

// The page has one visually hidden h1 that names what the map shows now:
// the default title, or "Mapa: <panel title>" for a list or a selection.
export function setPageHeading(text) {
    if (!pageHeadingEl) return;
    var value = text == null ? '' : String(text).trim();
    pageHeadingEl.textContent = value === '' ? PAGE_HEADING_DEFAULT : 'Mapa: ' + value;
}

export function setDetailsKicker(text) {
    if (!detailsKickerEl) return;
    var value = text == null ? '' : String(text);
    detailsKickerEl.textContent = value === '' ? DETAILS_KICKER_DEFAULT : value;
}

export function setDetailsMeta(text) {
    if (!detailsMetaEl) return;
    var value = text == null ? '' : String(text);
    var isEmpty = value === '';
    detailsMetaEl.textContent = value;
    detailsMetaEl.hidden = isEmpty;
    var headEl = detailsMetaEl.closest('.nm-panel-head');
    if (headEl) {
        headEl.hidden = isEmpty;
    }
}

export function setDetailsDepartment(department) {
    setDepartment(document.getElementById('nm-panel-details'), department);
}
export const nearbyMetaEl = document.getElementById('nm-nearby-meta');
export const nearbyContentEl = document.getElementById('nm-nearby-content');
export const openNearbyBtn = document.getElementById('nm-open-nearby');
export const detailCtaEl = document.getElementById('nm-detail-cta');
export const backToDetailsBtn = document.getElementById('nm-back-to-details');
export const personaBtn = document.getElementById('nm-persona-btn');
export const sheetEl = document.getElementById('nm-sheet');
export const sheetHandleEl = document.getElementById('nm-sheet-handle');
export const tabEls = document.querySelectorAll('.nm-tab');
export const panelEls = document.querySelectorAll('.nm-panel');
export const panelFooterEls = document.querySelectorAll('.nm-panel-footer');
export const panelScrollEls = document.querySelectorAll('.nm-panel-scroll');
export const assetEls = document.querySelectorAll('.nm-asset-btn');
export const assetSwitchEl = document.getElementById('nm-asset-switch');
export const filterScopeEls = document.querySelectorAll('[data-filter-scope]');
export const filterScopeSectionEls = document.querySelectorAll('[data-filter-scope-section]');
export const listingCategorySwitchEl = document.getElementById('nm-listing-category-switch');
export const listingCategoryEls = document.querySelectorAll('[data-listing-category-filter]');
export const listingCategoryMoreSelect = document.getElementById('nm-listing-category-more');
export const listingBrowseLinkEl = document.getElementById('nm-listing-browse-link');
export const listingActiveFiltersEl = document.getElementById('nm-listing-active-filters');
export const transactionActiveFiltersEl = document.getElementById('nm-transaction-active-filters');
export const sortEls = document.querySelectorAll('#nm-sort-row .nm-sort-chip');
export const addressInput = document.getElementById('nm-f-address');
export const addressSuggestEl = document.getElementById('nm-f-address-suggest');
export const addressRadiusKmInput = document.getElementById('nm-f-address-radius-km');
export const wojInput = document.getElementById('nm-f-woj');
export const terytInput = document.getElementById('nm-f-teryt');
export const terytSuggestEl = document.getElementById('nm-f-teryt-suggest');
export const terytHintEl = document.getElementById('nm-f-teryt-hint');
export const rodzajInput = document.getElementById('nm-f-rodzaj');
export const rynekInput = document.getElementById('nm-f-rynek');
export const listingCategoryInput = document.getElementById('nm-f-listing-category');
export const listingOfferTypeInput = document.getElementById('nm-f-listing-offer-type');
export const listingLocationQueryInput = document.getElementById('nm-f-listing-location-query');
export const listingLocationSuggestEl = document.getElementById('nm-f-listing-location-suggest');
export const listingRadiusKmInput = document.getElementById('nm-f-listing-radius-km');
export const listingMarketTypeInput = document.getElementById('nm-f-listing-market-type');
export const listingAdvertiserTypeInput = document.getElementById('nm-f-listing-advertiser-type');
export const listingPriceMinInput = document.getElementById('nm-f-listing-price-min');
export const listingPriceMaxInput = document.getElementById('nm-f-listing-price-max');
export const listingPricePerM2MinInput = document.getElementById('nm-f-listing-price-per-m2-min');
export const listingPricePerM2MaxInput = document.getElementById('nm-f-listing-price-per-m2-max');
export const listingAreaMinInput = document.getElementById('nm-f-listing-area-min');
export const listingAreaMaxInput = document.getElementById('nm-f-listing-area-max');
export const listingRoomsInput = document.querySelectorAll('[data-listing-checkbox-group="rooms"]');
export const listingFloorInput = document.querySelectorAll('[data-listing-checkbox-group="floor"]');
export const listingBuildYearMinInput = document.getElementById('nm-f-listing-build-year-min');
export const listingBuildYearMaxInput = document.getElementById('nm-f-listing-build-year-max');
export const listingBuildingFloorsMinInput = document.getElementById('nm-f-listing-building-floors-min');
export const listingBuildingFloorsMaxInput = document.getElementById('nm-f-listing-building-floors-max');
export const listingBuildingTypeInput = document.querySelectorAll('[data-listing-checkbox-group="building_type"]');
export const listingBuildingMaterialInput = document.querySelectorAll('[data-listing-checkbox-group="building_material"]');
export const listingFeaturesInput = document.querySelectorAll('[data-listing-checkbox-group="features"]');
export const listingHasPhotosInput = document.getElementById('nm-f-listing-has-photos');
export const listingOwnershipTypeInput = document.getElementById('nm-f-listing-ownership-type');
export const listingConditionInput = document.getElementById('nm-f-listing-condition');
export const listingHeatingTypeInput = document.getElementById('nm-f-listing-heating-type');
export const listingEnergyClassInput = document.getElementById('nm-f-listing-energy-class');
export const listingParkingInput = document.getElementById('nm-f-listing-parking');
export const listingRentalTermInput = document.getElementById('nm-f-listing-rental-term');
export const listingFurnishedInput = document.getElementById('nm-f-listing-furnished');
export const listingDepositMaxInput = document.getElementById('nm-f-listing-deposit-max');
export const listingPetPolicyInput = document.getElementById('nm-f-listing-pet-policy');
export const listingCreatedDaysInput = document.getElementById('nm-f-listing-created-days');
export const listingDescriptionQueryInput = document.getElementById('nm-f-listing-description-query');
export const listingPlotZoningInput = document.getElementById('nm-f-listing-plot-zoning');
export const listingRoadAccessInput = document.getElementById('nm-f-listing-road-access');
export const listingMpzpInput = document.getElementById('nm-f-listing-mpzp');
export const rokOdInput = document.getElementById('nm-f-rok-od');
export const rokDoInput = document.getElementById('nm-f-rok-do');
export const dzialkaIdInput = document.getElementById('nm-f-dzialka-id');
export const dzialkaIdHintEl = document.getElementById('nm-f-dzialka-id-hint');
export const parcelLocationQueryInput = document.getElementById('nm-f-parcel-location-query');
export const parcelLocationSuggestEl = document.getElementById('nm-f-parcel-location-suggest');
export const parcelIdInput = document.getElementById('nm-f-parcel-id');
export const parcelNumberInput = document.getElementById('nm-f-parcel-number');
export const parcelAreaInput = document.getElementById('nm-f-parcel-area');
export const parcelNeighbourNumbersInput = document.getElementById('nm-f-parcel-neighbour-numbers');
export const parcelNeighbourNumbersEditor = document.getElementById('nm-f-parcel-neighbour-numbers-editor');
export const parcelNeighbourNumbersValuesEl = document.getElementById('nm-f-parcel-neighbour-numbers-values');
export const parcelNeighbourAreasInput = document.getElementById('nm-f-parcel-neighbour-areas');
export const parcelNeighbourAreasEditor = document.getElementById('nm-f-parcel-neighbour-areas-editor');
export const parcelNeighbourAreasValuesEl = document.getElementById('nm-f-parcel-neighbour-areas-values');
export const parcelNeighbourRadiusInput = document.getElementById('nm-f-parcel-neighbour-radius');
export const parcelAreaToleranceInput = document.getElementById('nm-f-parcel-area-tolerance');
export const parcelResultsEl = document.getElementById('nm-f-parcel-results');
export const parcelUseMapBoundsBtn = document.getElementById('nm-f-parcel-use-map-bounds');
export const parcelMapBoundsStatusEl = document.getElementById('nm-f-parcel-map-bounds-status');
export const buildingLocationQueryInput = document.getElementById('nm-f-building-location-query');
export const buildingLocationSuggestEl = document.getElementById('nm-f-building-location-suggest');
export const buildingIdInput = document.getElementById('nm-f-building-id');
export const buildingFloorsAboveInput = document.getElementById('nm-f-building-floors-above');
export const buildingFloorsBelowInput = document.getElementById('nm-f-building-floors-below');
export const buildingResultsEl = document.getElementById('nm-f-building-results');
export const buildingUseMapBoundsBtn = document.getElementById('nm-f-building-use-map-bounds');
export const buildingMapBoundsStatusEl = document.getElementById('nm-f-building-map-bounds-status');
export const gunbRokWplywuOdInput = document.getElementById('nm-f-gunb-rok-wplywu-od');
export const bdot10kImpactClassificationInput = document.getElementById('nm-f-bdot10k-impact-classification');
export const bdot10kNuisanceLevelInput = document.getElementById('nm-f-bdot10k-nuisance-level');
export const bdot10kUsefulnessLevelInput = document.getElementById('nm-f-bdot10k-usefulness-level');
export const applyFiltersBtn = document.getElementById('nm-f-apply');
export const resetFiltersBtn = document.getElementById('nm-f-reset');
